import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: localStorage,
})

// function roleExists (userRoles, role) {
//   return userRoles.some(function (el) {
//     return el.description === role
//   })
// }

export default new Vuex.Store({
  strict: false,
  state: {
    token: null,
    user: null,
    client: null,
    isUserLoggedIn: false,
    isAdmin: false,
    passwordReset: false,
    currentPage: 'DATE',
    demoEmail: null,
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      if (token) {
        state.isUserLoggedIn = true
      } else {
        state.isUserLoggedIn = false
      }
    },
    setUser(state, user) {
      state.user = user
    },
    setClient(state, client) {
      state.client = client
    },
    setCurrentPage(state, page) {
      state.currentPage = page
    },
    setDemoEmail(state, email) {
      state.demoEmail = email
    },
  },
  actions: {
    setToken({ commit }, token) {
      commit('setToken', token)
    },
    setUser({ commit }, user) {
      commit('setUser', user)
    },
    setClient({ commit }, client) {
      commit('setClient', client)
    },
    setCurrentPage({ commit }, page) {
      commit('setCurrentPage', page)
    },
    setDemoEmail({ commit }, email) {
      commit('setDemoEmail', email)
    },
  },
  plugins: [vuexLocalStorage.plugin],
})
